import {svgIconWrapper} from '../svg-icon-wrapper';

import ExclamationRegular from './exclamation-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ExclamationRegular {...props} />;
}
SvgComponent.iconName = 'exclamationRegular';

export const ExclamationRegularIcon = svgIconWrapper(SvgComponent);
